<!--
  Text/SMS invites — tabs wrapper cloning EmailInvites23/EmailInvites.vue (June '26).
  The old single-page Textinvites.vue was split into Send / Auto Followups / History
  when SMS followups shipped.
-->
<template>
    <div>
        <Pagesubtitle subTitle="Send bulk text/SMS invites for feedback. You can also send an invite to yourself and forward to customers personally." />
        <vs-tabs v-model="currentTab">
            <vs-tab label="Send Invites" class="nofilterimags px-0">
                <SendTextinvites/>
            </vs-tab>
            <vs-tab label="Auto Followups" class="nofilterimags px-0">
                <TextFollowup/>
            </vs-tab>
            <vs-tab label="Invite History" class="nofilterimags px-0">
                <TextInviteHistory/>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>

import Pagesubtitle from '../components/ptcomponents/Pagesubtitle.vue'
import SendTextinvites from './SendTextinvites.vue'
import TextFollowup from './TextFollowup.vue'
import TextInviteHistory from './TextInviteHistory.vue'

export default {
    data() {
        return {
            currentTab: 0
        }
    },
    components: {
        SendTextinvites,
        Pagesubtitle,
        TextFollowup,
        TextInviteHistory
    }
}

</script>
